import { render, staticRenderFns } from "./doc-preview.vue?vue&type=template&id=e98ea41e&scoped=true"
import script from "./doc-preview.vue?vue&type=script&lang=js"
export * from "./doc-preview.vue?vue&type=script&lang=js"
import style0 from "./doc-preview.vue?vue&type=style&index=0&id=e98ea41e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98ea41e",
  null
  
)

export default component.exports